import { Component, Input, OnInit, inject, DOCUMENT } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SmService } from '@pages/sm/services/sm.service';
import { SmDataService } from '@pages/sm/services/sm-data.service';
import { PortalSettingsService } from '@core/services/portal-settings.service';


@Component({
    selector: 'app-complete-trip-modal',
    templateUrl: './complete-trip-modal.component.html',
    styleUrls: ['./complete-trip-modal.component.css'],
    standalone: false
})
export class CompleteTripModalComponent implements OnInit {
  // Injected services
  private readonly ngbActiveModal = inject(NgbActiveModal);
  private readonly smService = inject(SmService);
  private readonly portalSettings = inject(PortalSettingsService).getPortalSettings();
  private readonly document = inject(DOCUMENT);
  private readonly window = this.document.defaultView!;
  public readonly smDataService = inject(SmDataService);

  // Inputs
  @Input() lookup: any;
  @Input() isCollectSignature: any;
  @Input() currentTrip: any;
  @Input() clockStatus: any;

  // Private fields
  private scopeDetails: any;
  private overheadCallTypes: string[] = [];
  private smDaysFromTripClosedToShowWorkOrder: number | null =
    this.portalSettings?.SMDaysFromTripClosedToShowWorkOrder?.ConfigValue != null
      ? Number(this.portalSettings.SMDaysFromTripClosedToShowWorkOrder.ConfigValue)
      : null;

  // Public fields
  loadAttachData = false;
  closeReturnTripRequired = false;
  collectPayment = false;
  bypassAttach = false;
  closeReturnTripReason: string;
  closeNotes: string;
  allCheck = false;

  closeCount = 0;
  stopCompleteTrip = false;
  closeOutMissCompleteForm = false;
  missingRequireForm: any;
  SMHideReturnTrip = false;
  closeOutMissingCallType = false;
  closeOutMissingScopeNotes = false;
  RequiredTripNotes: any;
  missingCallType: any;
  missingScopeNotes: string[] = [];
  alertCall: any;
  alertForm: any;
  alertScopeNotes: string;
  headerText: any;
  SMHideAttachmentOnComplete = this.portalSettings?.SMHideAttachmentOnComplete?.ConfigValue === '1';
  SMEnablePaymentCollection = this.portalSettings?.SMEnablePaymentCollection?.ConfigValue === '1';

  ngOnInit(): void {
    if (this.SMHideAttachmentOnComplete) {
      this.bypassAttach = true;
    }
    this.headerText = 'WO ' + this.currentTrip.WorkOrder + ' - ' + (this.isCollectSignature ? 'Collect Signature' : 'Trip Completion');

    this.smService.getWorkOrderScopes('?sMWorkOrderID=' + this.currentTrip.SMWorkOrderID).then((response: any) => {
      this.scopeDetails = response;
    });

    if (this.isCollectSignature == false) {
      this.smService.getSettingsBySMCo(this.currentTrip.SMCo).then((response: any) => {
        this.SMHideReturnTrip = response[0].TripCloseSetting == 'D';
        this.RequiredTripNotes = response[0].RequiredTripNotes;
        this.overheadCallTypes = response[0].SMOverheadCallTypes ? response[0].SMOverheadCallTypes.split(',').map(x => x.trim()) : [];
      });
    }

    if (
      this.clockStatus?.ClockAction &&
      this.currentTrip?.SMTripID === this.clockStatus?.SMTripID &&
      this.isCollectSignature === false &&
      (this.smDaysFromTripClosedToShowWorkOrder === 0 || this.smDaysFromTripClosedToShowWorkOrder === null)
    ) {
      this.stopCompleteTrip = true;
    }

    this.currentTrip.ScopeData.forEach((val, key) => {
      val.IsClose = false;
      if (!this.smDataService.currentOnline && val.SMWorkOrderScopeID == this.smDataService.currentWorkOrderScopeData.SMWorkOrderScopeID) {
        val.IsClose = true;
        this.closeCount++;
        this.continueClicked();
      }
    });
  }

  closeRequireUpdate(): void {
    this.closeReturnTripReason = null;
    this.closeNotes = null;
  }

  previewCompleteTrip(): void {
    let tempScopes = '';
    let tempUnique = '';

    this.currentTrip.ScopeData.forEach((val, key) => {
      if (val.IsClose == true) {
        tempScopes += val.SMWorkOrderScopeID + ',';
        tempUnique += val.UniqueAttchID != null ? val.UniqueAttchID + ',' : ',';
      }
    });
    this.window.open(
      '/SM/PreviewCompleteTrip?sMTripID=' +
      this.currentTrip.SMTripID +
      '&sMWorkOrderID=' +
      this.currentTrip.SMWorkOrderID +
      '&scopes=' +
      tempScopes +
      '&unique=' +
      tempUnique +
      '&sMCO=' +
      this.currentTrip.SMCo +
      '&filename=' +
      this.currentTrip.WorkOrder +
      '_' +
      this.currentTrip.TripDescription +
      '_Completion',
      '_blank'
    );
  }

  checkAll(): void {
    let count = 0;

    this.currentTrip.ScopeData.forEach((val, key) => {
      val.IsClose = this.allCheck;
      count++;
    });
    this.closeCount = this.allCheck ? count : 0;
  }

  updateCheck(IsClose: boolean): void {
    IsClose ? this.closeCount++ : this.closeCount--;
    this.allCheck = this.closeCount == this.currentTrip.ScopeData.length;
  }

  hideAttachmentChange(): void {
    this.loadAttachData = false;
  }

  continueClicked(): void {
    this.closeOutMissCompleteForm = false;
    this.closeOutMissingCallType = false;
    this.closeOutMissingScopeNotes = false;

    const scopeDetails = this.scopeDetails ?? this.currentTrip?.ScopeData ?? [];

    const tempClose = [];
    const tempCloseInt = [];
    let tempCloseExcludeForInvoice = '';
    this.missingCallType = '';
    this.missingScopeNotes = [];

    const callTypes = scopeDetails.map((scope: any) => scope.CallType);
    // Only skip if All scopes have valid CallTypes and All are overhead types
    const allOverhead =
      callTypes.length > 0 && callTypes.every((ct: string | null | undefined) => ct && this.overheadCallTypes.includes(ct));

    this.currentTrip.ScopeData.forEach((scope: any) => {
      if (scope.IsClose == true) {
        tempClose.push(scope);
        tempCloseInt.push(scope.SMWorkOrderScopeID);

        scopeDetails
          .filter((detail: any) => detail.SMWorkOrderScopeID == scope.SMWorkOrderScopeID)
          .forEach((scopeDetail: any) => {
            if (this.smDataService.SMCallTypeRequire && scopeDetail.CallType == null) {
              this.closeOutMissingCallType = true;
              this.missingCallType += scopeDetail.Scope + ',';
            }

            const scopeNotes: string = (scopeDetail.ScopeNotes ?? '').toString();
            if (this.smDataService.SMRequireScopeNotes && !scopeNotes.trim()) {
              this.closeOutMissingScopeNotes = true;
              this.missingScopeNotes.push(scopeDetail.Scope);
            }
          });
      } else {
        tempCloseExcludeForInvoice += scope.SMWorkOrderScopeID + ',';
      }
    });

    if (this.closeOutMissingCallType) {
      this.alertCall = 'The following call types are required to be finished prior to completing the trip:';
    }

    if (this.closeOutMissingScopeNotes) {
      this.alertScopeNotes = 'The following scopes are missing required scope notes prior to completing the trip:';
    }

    if (this.isCollectSignature) {
      this.ngbActiveModal.close({
        closeList: tempClose,
        justComplete: false,
        loadAttachData: this.loadAttachData,
        bypassAttach: this.bypassAttach,
      });
    } else {
      if (!this.closeOutMissingCallType && !this.closeOutMissingScopeNotes) {
        this.smService.getFormsPerScopeMulti(tempCloseInt, this.currentTrip.SMTripID).then((response: any) => {
          const templateList = response;
          this.missingRequireForm = [];
          if (templateList != null) {
            templateList.forEach((val, key) => {
              //#513672 - Required Fields of the form need to be completed before completing the trip
              if (val.IsMissingRequiredFields) {
                this.closeOutMissCompleteForm = true;
                this.missingRequireForm.push(val);
              }
            });
          }
          if (this.closeOutMissCompleteForm) {
            this.alertForm = 'The following forms are required to be finished prior to completing the trip:';
          } else {
            // allOverhead check here, after required forms validation
            if (allOverhead) {
              this.smService
                .completeTrip({
                  sMTripID: this.currentTrip.SMTripID,
                  sMWorkOrderID: this.currentTrip.SMWorkOrderID,
                  revisitRequired: this.closeReturnTripRequired,
                  revisitReason: this.closeReturnTripReason,
                  revisitNotes: this.closeNotes,
                  justComplete: true,
                  justSendEmail: false,
                })
                .then((response: any) => {
                  this.ngbActiveModal.close({ success: response, justComplete: true });
                });
              return;
            }

            this.smDataService.isReadyToCompleteSelected = false;
            if (this.closeCount == 0) {
              this.smService
                .completeTrip({
                  sMTripID: this.currentTrip.SMTripID,
                  sMWorkOrderID: this.currentTrip.SMWorkOrderID,
                  revisitRequired: this.closeReturnTripRequired,
                  revisitReason: this.closeReturnTripReason,
                  revisitNotes: this.closeNotes,
                  justComplete: true,
                  justSendEmail: false,
                })
                .then((response: any) => {
                  this.ngbActiveModal.close({ success: response, justComplete: true });
                });
            } else {
              this.ngbActiveModal.close({
                closeList: tempClose,
                revisitRequired: this.closeReturnTripRequired,
                revisitReason: this.closeReturnTripReason,
                revisitNotes: this.closeNotes,
                justComplete: false,
                loadAttachData: this.loadAttachData,
                collectPayment: this.collectPayment,
                bypassAttach: this.bypassAttach,
                tempCloseExcludeForInvoice: tempCloseExcludeForInvoice,
              });
            }
          }
        });
      }
    }
  }

  cancelClicked(): void {
    if (this.smDataService.isReadyToCompleteSelected) {
      this.smDataService.allShow = true;
      this.smDataService.currentWorkOrder.showScope = false;
      this.smDataService.currentWorkOrder = null;
      this.smDataService.isReadyToCompleteSelected = false;
    }
    this.ngbActiveModal.dismiss();
  }
}
